import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack } from '@mui/material';
import { styled } from '@mui/styles';
import { Link } from 'react-router-dom';

import { TextStyle, customScrollbarStyle } from '../../../assets/styles/custom.styles';
import { TenantOverviewObject } from '../../../Page/customer/partner/customer/customerOverviewPage';
import LoadingComponent from '../../common/loadingComponent';

interface CustomerOverviewProps {
  isLoading: boolean;
  isError: boolean;
  errorText: string;
  list: Array<TenantOverviewObject>
}

const formatDate = (date: string | null) =>  {
  if (date === null)
    return 'No Date';
  return new Date(date).toLocaleDateString(import.meta.env.VITE_LOCALE, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').join('-');
};

const container = {
  border:'1px solid rgba(0, 0, 0, 0.16)',
  borderRadius: '8px',
  maxWidth: '100%',
  maxHeight: 'calc(100vh - 150px)',
  ...(customScrollbarStyle),
};
const tableStyle = {
  maxHeight: 'calc(100vh - 300px)',
  overflowY:'auto',
};

const HeaderCell = styled(TableCell)({
  color: '#878787!important',
  fontSize: '14px',
  fontWeight: 500,
});
const BodyCell = styled(TableCell)({
  color: '#181818',
  fontSize: '14px',
  fontWeight: 500,
});


const CustomerOverview = ({ isLoading, isError, errorText, list }: CustomerOverviewProps) => {
  return (
    <Stack component={Paper} sx={container}>
      <Typography sx={{
        ...TextStyle.headerText, 
        padding: '1.5rem 1.25rem' }}
      >List of All Customers
      </Typography>
      <TableContainer sx={customScrollbarStyle}>
        <Table stickyHeader sx={tableStyle}>
          <TableHead>
            <TableRow>
              <HeaderCell>Company</HeaderCell>
              <HeaderCell>All User</HeaderCell>
              <HeaderCell>Language</HeaderCell>
              <HeaderCell>Payment Status</HeaderCell>
              <HeaderCell>
                <Stack>
                  <Typography sx={{ fontSize: '14px' }}>Subscription Start</Typography>
                  <Typography sx={{ fontSize: '14px' }}>(dd-mm-yy)</Typography>
                </Stack>
              </HeaderCell>
              <HeaderCell>
                <Stack>
                  <Typography sx={{ textAlign: 'start', fontSize: '14px' }}>Subscription End</Typography>
                  <Typography sx={{ textAlign: 'start', fontSize: '14px' }}>(dd-mm-yy)</Typography>
                </Stack>
              </HeaderCell>
              <HeaderCell>Actions</HeaderCell>
            </TableRow>
          </TableHead>
          {!isLoading &&
              <TableBody>
                {Array.isArray(list) && list.length > 0 && 
                list.map(({ 
                  name, 
                  slug,
                  languages,
                  paymentStatus,
                  subscriptionStartDate, 
                  subscriptionBillingDate,
                }) => (
                  <TableRow key={slug}>
                    <BodyCell sx={{ maxWidth:'150px' }}>
                      <Link 
                        to = {`/customer/backoffice/customer/overview/${slug}`} 
                        style={{ 
                          color: '#181818',
                          textDecoration: 'none',  
                        }}>
                        {name}
                      </Link>
                    </BodyCell>
                    <BodyCell sx={{ maxWidth:'150px' }}>
                      <Link 
                        to = {`/customer/backoffice/customer/${slug}/users`} 
                        style={{ 
                          color: '#181818',
                          textDecoration: 'none',  
                        }}>
                        View
                        <ChevronRightIcon sx={{ marginBottom: '-7px' }}/>
                      </Link>
                    </BodyCell>
                    <BodyCell sx={{ maxWidth:'100px', color: '#878787!important' }}>
                      {languages.map(language => language.name).join(', ')}
                    </BodyCell>
                    <BodyCell sx={{ maxWidth:'50px', color:'#878787!important' }}>{paymentStatus}</BodyCell>
                    <BodyCell sx={{ width:'175px' }}>
                      {formatDate(subscriptionStartDate)}
                    </BodyCell>
                    <BodyCell sx={{ width:'175px' }}>
                      {formatDate(subscriptionBillingDate)}
                    </BodyCell>
                    <BodyCell sx={{ width:'120px', textAlign: 'end'  }}>
                      <Link 
                        to = {`/customer/backoffice/customer/overview/${slug}`} 
                        style={{ 
                          color: '#181818',
                          textDecoration: 'none',  
                        }}>
                        Update
                        <ChevronRightIcon sx={{ marginBottom: '-7px' }}/>
                      </Link>
                    </BodyCell>
                  </TableRow>
                )) 
                }
              </TableBody>
          }
        </Table>
        {isLoading && <LoadingComponent isMinHeight/>}
        {!isLoading && isError &&
            <Typography sx={{
              textAlign: 'center',
              padding:'40px',
              color:'#FF5E56',
            }}>{errorText}</Typography>
        }
      </TableContainer>
    </Stack>
  );
};

export default CustomerOverview;
